class CustomSwiper extends HTMLElement {
  constructor() {
    super();
    this.slidesPerView_pc = Number(this.getAttribute("data-row")) || 4
    this.slidesPerView_table = Number(this.getAttribute("data-table-row")) || 3
    this.slidesPerView_m = Number(this.getAttribute("data-rowm")) || 2
    this.has_button = this.getAttribute("data-button") == "true"
    this.has_pagination = this.getAttribute("data-pagination") == "true"
    this.is_free = this.getAttribute("data-free") == "true"
    
  }
   connectedCallback() {
    setTimeout(() => this.initSwiper(), 0);
  }

  initSwiper(){
    const nextEl = this.querySelector('.swiper-button-next');
    const prevEl = this.querySelector('.swiper-button-prev');
    const pagination = this.querySelector('.swiper-pagination');
    const swiperContainer = this.querySelector('.custom-swiper-container') || this;
    const slideCount = this.querySelectorAll('.swiper-slide').length;
    const config = {
      slidesPerView: this.slidesPerView_m,
      spaceBetween: 10,
      allowTouchMove: slideCount > this.slidesPerView_m,
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerView_table,
          spaceBetween: 20,
          allowTouchMove: slideCount > this.slidesPerView_table
        },
        1280:{
              slidesPerView: this.slidesPerView_pc,
          spaceBetween: 20,
          allowTouchMove: slideCount > this.slidesPerView_pc
        }
      }
    };
    if (this.has_button && nextEl && prevEl) {
      config.navigation = {
        nextEl,
        prevEl
      };
    }
     if (this.has_pagination && pagination) {
      config.pagination= {
        el: pagination
      }
    }
     if (this.is_free) {
      config.pagination= {
        freeMode: true
      }
    }
    new Swiper(swiperContainer, config);
  }

}

customElements.define('custom-swiper', CustomSwiper)
class CustomPopCountdown extends HTMLElement {
  constructor() {
    super();
    this.endDate = new Date(localStorage.getItem("endDate")) || null
    this.getOrResetTime()
    this.initInterval()
    this.timer = setInterval(this.initInterval.bind(this), 1000);
  }
  getOrResetTime(){
    const now = new Date();
    if (this.endDate == null || new Date(this.endDate) < now) {
       this.endDate = new Date(now.getTime() + 5 * 60 * 60 * 1000);
      localStorage.setItem("endDate",this.endDate)
    }
  }
  initInterval(){
        const now = new Date();
        const diff = this.endDate - now;
        if (diff <= 0) {
            this.closest(".custom-popup-section").style.display = "none"
            clearInterval(this.timer);
            return;
        }
        let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((diff % (1000 * 60)) / 1000);
        hours = hours >= 10 ? hours.toString() : "0" + hours
        minutes = minutes >= 10 ? minutes.toString() : "0" + minutes
        seconds = seconds >= 10 ? seconds.toString() : "0" + seconds
        this.querySelector(".custom-countdown-new-hours").querySelectorAll("div")[0].innerHTML = hours.split("")[0]
        this.querySelector(".custom-countdown-new-hours").querySelectorAll("div")[1].innerHTML = hours.split("")[1]
        this.querySelector(".custom-countdown-new-mins").querySelectorAll("div")[0].innerHTML = minutes.split("")[0]
        this.querySelector(".custom-countdown-new-mins").querySelectorAll("div")[1].innerHTML = minutes.split("")[1]
        this.querySelector(".custom-countdown-new-seconds").querySelectorAll("div")[0].innerHTML = seconds.split("")[0]
        this.querySelector(".custom-countdown-new-seconds").querySelectorAll("div")[1].innerHTML = seconds.split("")[1]
  }
 
}

customElements.define('custom-pop-countdown', CustomPopCountdown);



class CustomCopy extends HTMLElement {
  constructor() {
    super();
    this.code = this.getAttribute("data-text")
    this.status = this.getAttribute("data-status")
    this.wrapper = this.querySelector(".custom-copy-content") || this
    this.addEventListener("click", this.handleClick.bind(this));
  }

    async handleClick() {
    if (this.status == "yes") return
        await this.copyToClipboard(this.code);
        this.setAttribute("data-status", "yes");
        this.status="yes"
        this.wrapper.innerHTML = "Copied";
  }
   copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        if (ta.setSelectionRange) ta.setSelectionRange(0, ta.value.length);
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error("execCommand failed"));
      } catch (err) {
        reject(err);
      }
    });
  }
}

customElements.define('custom-copy', CustomCopy);

$(".custom-pop-form-submit").click(function(){
  if($(this).hasClass("is--loading")) return
  $(this).addClass("is--loading")
  return
})


function closeCustomPop(){
   document.querySelector(".custom-popup-section").style.display = "none"
   $(".custom-popup-section").fadeOut()
}
function openCustomPop(){
  setTimeout(function() {
   $(".custom-popup-section").fadeIn()
     const now = Date.now();
      localStorage.setItem("customPopDate",now)
      localStorage.setItem("customPopStatus","true")
  },30000)
}
let is_open_custom_pop = JSON.parse(localStorage.getItem("customPopStatus")) || false
let lastPopTime = parseInt(localStorage.getItem("customPopDate"), 10) || 0;
let currentDate = new Date()
const ONE_WEEK = 7 * 24 * 60 * 60 * 1000
if(!is_open_custom_pop || currentDate - lastPopTime > ONE_WEEK){
    openCustomPop()
}

$(".custom-popup-section").click(function(){
  closeCustomPop()
}) 
$(".custom-popup-content").click(function(e){
  e.stopPropagation()
}) 
$(".close-popup-button").click(function(){
  closeCustomPop()
}) 
$(".js_open_custom-popup").click(function(){
   $(".custom-popup-section").find("custom-pop-countdown").hide()
   $(".custom-popup-section").fadeIn()
})




class CustomCountdownDay extends HTMLElement {
  constructor() {
    super();
  }
   connectedCallback() {
    this.updateCountdown();
    this.timer = setInterval(this.updateCountdown.bind(this), 1000);
  }
  updateCountdown(){
        let now = new Date();
        let end = new Date(now);
        end.setDate(now.getDate() + 1); 
        end.setHours(0, 0, 0, 0); 
        
        let diff = end - now;
        let days = Math.floor(diff / (1000 * 60 * 60 * 24));
        let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((diff % (1000 * 60)) / 1000);
        days = days >= 10 ? days : "0" + days
        hours = hours >= 10 ? hours : "0" + hours
        minutes = minutes >= 10 ? minutes : "0" + minutes
        seconds = seconds >= 10 ? seconds : "0" + seconds
        this.querySelector(".coundown-content").innerHTML = `${hours}:${minutes}:${seconds}`
  }
 
}

customElements.define('custom-countdown-day', CustomCountdownDay);




class CustomPop extends HTMLElement {
  constructor() {
    super();
    this.openBtn = this.querySelector(".custom-pop-button")
    this.content = this.querySelector(".custom-pop-content").innerHTML
    this.modal = null; 
    this.isBound = false; 
  }

  connectedCallback() {
    if (this.openBtn && !this.isBound) {
      this.openBtn.addEventListener("click", () => this.openModal());
      this.isBound = true;
    }
  }

  openModal() {
    this.modal = document.createElement("div");
    this.modal.classList.add("custom-pop-wrapper");
    let modal_content = this.content
    const content = document.createElement("div");
    content.classList.add("custom-pop-container");

    // 关闭按钮
    const closeBtn = document.createElement("span");
    closeBtn.innerHTML = `<svg t="1758873248848" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4788" width="20" height="20"><path d="M631 485.84l309.77-309.78a65.63 65.63 0 0 0 0-92.83 65.63 65.63 0 0 0-92.83 0L538.16 393a37 37 0 0 1-52.32 0L176.06 83.23a65.63 65.63 0 0 0-92.83 0 65.63 65.63 0 0 0 0 92.83L393 485.84a37 37 0 0 1 0 52.32L83.23 847.94a65.63 65.63 0 0 0 0 92.83 65.63 65.63 0 0 0 92.83 0L485.84 631a37 37 0 0 1 52.32 0l309.78 309.77a65.63 65.63 0 0 0 92.83 0 65.63 65.63 0 0 0 0-92.83L631 538.16a37 37 0 0 1 0-52.32z" p-id="4789"></path></svg>`;
    closeBtn.classList.add("close-pop-button");
    closeBtn.addEventListener("click", () => this.closeModal());
    content.innerHTML = modal_content;
    content.appendChild(closeBtn);
    this.modal.appendChild(content);
    this.modal.addEventListener("click", (e) => {
      if (e.target === this.modal) this.closeModal();
    });
    document.body.appendChild(this.modal);
    document.body.classList.add("t4s-lock-scroll", "is--opend-drawer");
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.remove();
    this.modal = null;
    document.body.classList.remove("t4s-lock-scroll", "is--opend-drawer");
  }
}
customElements.define('custom-pop', CustomPop);
